var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search_icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7991322,23.7755286 L19.9013757,17.8594092 C22.5784499,14.6309924 22.2444008,9.86971987 19.1427334,7.0463186 C16.041066,4.22291733 11.266935,4.33429034 8.30044065,7.29925235 C5.33394629,10.2642144 5.22251572,15.0358792 8.04737618,18.1359445 C10.8722366,21.2360097 15.6359699,21.5698862 18.8660552,18.8941949 L24.7638117,24.7889049 C24.8978798,24.924007 25.0803788,25 25.2707618,25 C25.4611447,25 25.6436438,24.924007 25.7777118,24.7889049 C25.9157552,24.6577824 25.9956707,24.4769758 25.9998526,24.2866779 C26.0037156,24.0963801 25.9315117,23.9123614 25.7991322,23.7755286 Z M7.44182941,12.8638922 C7.44182941,9.31667353 10.3189045,6.44108463 13.8679564,6.44108463 C17.4170084,6.44108463 20.2940834,9.31667353 20.2940834,12.8638922 C20.2940834,16.4111109 17.4170084,19.2866998 13.8679564,19.2866998 C10.3189045,19.2866998 7.44182941,16.4111109 7.44182941,12.8638922 Z",
    id: "Shape",
    fill: "#878787",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMagnifier);
export default __webpack_public_path__ + "static/media/search-magnifier.a9d0c207.svg";
export { ForwardRef as ReactComponent };